module.exports = __webpack_public_path__ + "assets/img/677400bfd581842d5ad9620b0676906c.png";